document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initParallaxHero();
  initTiltCards();
  initCorregirCajonCarrito();
});

// Arreglo defensivo: la ventana de "producto añadido" a veces se queda
// atascada en su posición cerrada (fuera de pantalla) porque su animación
// CSS no llega a completarse. En cuanto se marca como abierta, forzamos su
// posición final tras un breve margen, sin tocar los archivos nativos.
function initCorregirCajonCarrito() {
  var notif = document.getElementById('cart-notification');
  if (!notif) return;
  var observer = new MutationObserver(function () {
    if (notif.classList.contains('active')) {
      setTimeout(function () {
        if (notif.classList.contains('active')) {
          notif.getAnimations().forEach(function (anim) { anim.finish(); });
        }
      }, 260);
    }
  });
  observer.observe(notif, { attributes: true, attributeFilter: ['class'] });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var dur = 1400;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        var val = fin * ease;
        el.textContent = (fin % 1 === 0) ? Math.round(val) : val.toFixed(1);
        if (p < 1) requestAnimationFrame(paso);
        else el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initParallaxHero() {
  var heroImgs = document.querySelectorAll('[data-mt-parallax]');
  if (!heroImgs.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function actualizar() {
    heroImgs.forEach(function (el) {
      var rect = el.closest('.mt-section').getBoundingClientRect();
      var progreso = 1 - Math.min(Math.max(rect.top / window.innerHeight, -1), 1);
      var offset = (progreso - 0.5) * 26;
      el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });
  actualizar();
}

function initTiltCards() {
  var cards = document.querySelectorAll('[data-mt-tilt]');
  if (!cards.length) return;
  if (window.matchMedia('(hover: none)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(700px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (y * -6).toFixed(2) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
